<template>
  <div class="main-content">
    <div class="flex align-items marginBottom20" style="padding: 10px 10px 0 10px;">
      <el-button icon="el-icon-back" size="small" @click="goBack">返回</el-button>
      <span class="marginLeft20" style="font-size: 16px; font-weight: bold;">项目信息</span>
    </div>
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >项目名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleCreate('create')"
                >新增项目</el-button
              >
            </div>
          </div>
        </div>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleCreate('update', row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          >删除</el-button
        >
      </template>
    </avue-crud>

    <InfoForm
      ref="formRef"
      @success="handleSearch"
      :classifyList="classifyList"
    />
  </div>
</template>

<script>
import {
  factoryManageProjectList,
  factoryManageProjectAdd,
  factoryManageProjectUpdate,
  factoryManageProjectDelete,
} from "@/api/factory/projectInfo";
import { mapGetters } from "vuex";
import { mobilePhoneRule } from "@/utils/formRules";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import InfoForm from "./infoForm.vue";

export default {
  name: "index",
  components: {
    FormImgUpload,
    InfoForm,
  },

  data() {
    return {
      button: {},
      isDetails: false,
      searchData: {
        name: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "项目ID",
            prop: "id",
          },
          {
            label: "项目名称",
            prop: "projectName",
          },
          {
            label: "项目时间",
            prop: "projectDate",
          },
          {
            label: "下单金额(元)",
            prop: "projectAmount",
          },
        ],
      },

      dialogVisible: false,
      form: {
        image: [],
        equityIds: [],
      },
      dialogPassWordVisible: false,
      dataUrl: "",
      classifyList: [], //分类下拉
    };
  },
  created() {},
  methods: {
    //初始化
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      this.showLoading = true;
      factoryManageProjectList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
        factoryId: this.$route.query.id,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },
    handleCreate(type, row) {
      this.$refs.formRef.open(type, row);
    },
    // 查询
    handleSearch() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      this.searchData = {
        title: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        factoryManageProjectDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
      };
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 查询
    handleSearch() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 返回
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
img {
  width: 100%;
  height: 100%;
}
</style>
